import { render, staticRenderFns } from "./dashboard-table.vue?vue&type=template&id=a0032cec"
import script from "./dashboard-table.vue?vue&type=script&lang=js"
export * from "./dashboard-table.vue?vue&type=script&lang=js"
import style0 from "./dashboard-table.vue?vue&type=style&index=0&id=a0032cec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports